<template>
    <div :class="{'table-card-selected': selected}" class="table-card">
        <checkbox
            :binary="true"
            :class="{'table-card-checkbox-selected': selected}"
            :modelValue="selected"
            class="table-card-checkbox checkbox-big"
            @input="$event ? $emit('selected') : $emit('unselected')" />

        <thumbnail-hover-zoom
            @thumbnailPreviewClick="$emit('thumbnailPreviewClick', entry?.id)"
            :editLink="editLink"
            :entry="entry"
            :showIcon="true"
        />

        <div :id="`btnSet${entry.id}`"
             :class="{'table-card-buttons-menu-open': dropdownMenuOpen}"
             class="table-card-buttons">

            <square-button
                :buttonClasses="[{'menu-open': dropdownMenuOpen}, 'table-card-button']"
                icon="fas fa-ellipsis-vertical"
                tabindex="-1"
                @click="$emit('menu-button-click')"
            />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

import Checkbox from '../PrimeVue/Checkbox.vue'

import ListDropdownMenu from '../list-dropdown-menu.vue'
import SquareButton from '../squareButton.vue'
import ThumbnailHoverZoom from '../thumbnailHoverZoom.vue'

import { Portal } from '@linusborg/vue-simple-portal'

export default defineComponent({
    components: {
        ThumbnailHoverZoom,
        SquareButton,
        ListDropdownMenu,
        Checkbox,
        Portal
    },
    props: {
        entry: {
            type: Object,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        dropdownMenuOpen: {
            type: Boolean,
            required: true
        },
        menuDropdownItems: {
            type: Array,
            required: true
        },
        getEditLink: {
            type: Function,
            required: true
        }
    },
    computed: {
        editLink() {
            return this.getEditLink(this.entry.id)
        }
    },
    methods: {
        onClick() {
            window.location = this.editLink
        }
    }
})
</script>

<style lang="scss">
.table-card {
    position: relative;

    background-color: #fff;
    color: rgba(0, 0, 0, .87);

    border-radius: 4px;
    overflow: hidden;
    width: 200px; /* IMG_CONTAINED_WIDTH */
    outline: #ced4da solid 2px;

    transition: outline-color 83.334ms ease,
    outline-width 83.334ms ease,
    box-shadow 83.334ms ease;

    &.table-card-selected {
        outline-color: var(--color-primary, #003371);
        outline-width: 4px;
        box-shadow: 1px 1px 2px 5px var(--color-primary-shadow, #00337166);
    }

    &:hover img,
    &:focus img {
        transform: scale(var(--scale-factor-hover)) !important;
    }

    .table-card-checkbox {
        position: absolute;
        --dimension: 32px;
        --padding-top-start: 6px;
        --padding-bottom-end: 6px;
        padding: var(--padding-top-start) var(--padding-bottom-end) var(--padding-bottom-end) var(--padding-top-start);
        width: calc(var(--dimension) + var(--padding-top-start) + var(--padding-bottom-end)) !important;
        height: calc(var(--dimension) + var(--padding-top-start) + var(--padding-bottom-end)) !important;

        z-index: 1;

        /*backdrop-filter: unset;
        mask: radial-gradient(circle at 0 0, #000 34px, #0000 40px),
        radial-gradient(circle at 7px 7px, #000 28px, #0000 34px),
        radial-gradient(circle at 18px 18px, #000 18px, #0000 22px);*/

        /*transform: translateX(-100%);*/
        opacity: 0;
        transition: /*transform 150ms ease,*/
            opacity 150ms ease-out /*, backdrop-filter 150ms ease-out*/
    ;
    }

    .table-card-buttons {
        position: absolute;
        top: 2px;
        right: 2px;
        display: flex;
        flex-direction: column;
        gap: 2px;
        color: white;

        transform: translateX(calc(100% + 2px));
        opacity: 0;
        pointer-events: none;
        transition: transform 150ms ease-out, opacity 150ms ease-out;

        .table-card-button {
            aspect-ratio: 1;
            border: unset;
        }
    }

    .thumbnail-hoverzoom-container > .image-title-text.past {
        background-color: var(--color-state-tobesynced) !important;
        color: black !important;
    }

    .thumbnail-hoverzoom-container > .image-title-text.future {
        background-color: var(--color-state-synced) !important;
        color: white !important;
    }
}

.table-card-buttons:hover,
.table-card-buttons:focus,
.table-card:hover .table-card-buttons,
.table-card:focus .table-card-buttons,
.table-card-buttons-menu-open {
    transform: unset;
    opacity: 1;
    pointer-events: all;
}

.table-card-buttons.table-card-buttons-menu-open,
.table-card-checkbox.p-checkbox-focused,
.table-card:hover .table-card-checkbox,
.table-card:focus .table-card-checkbox,
.table-card-checkbox-selected {
    transform: unset;
    opacity: 1;
}

</style>
